// components/RedirectToDashboard.tsx
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSessionStore } from "../../../store/useSessionStore";
import { getWorkspaceByRole } from "../../../utils/portal";

const RedirectToDashboard = () => {
  const { token, username, userRole, userIdData } = useParams();
  const navigate = useNavigate();
  const setSession = useSessionStore((state) => state.setSession);

  useEffect(() => {
    if (token && username && userRole && userIdData) {
      localStorage.setItem("access_token", decodeURIComponent(token));
      localStorage.setItem("username", username);
      localStorage.setItem("userRole", userRole);
      localStorage.setItem("selectedPortal", getWorkspaceByRole(userRole));
      setSession({
        token: decodeURIComponent(token),
        userRole,
        userName: username,
        userIdData,
      });

      // redirect to clean URL
      navigate("/dashboard", { replace: true });
    }
  }, [token, username, userRole, userIdData, setSession, navigate]);

  return null; // no UI needed
};

export default RedirectToDashboard;
